var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.625,
    y: 0.625,
    width: 13.75,
    height: 13.75,
    rx: 6.875,
    stroke: "#29185E",
    strokeWidth: 1.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3339 5.43582C10.5554 5.6837 10.5554 6.08551 10.3339 6.33327L6.52931 10.5905C6.30778 10.8383 5.94879 10.8383 5.72726 10.5905L3.91615 8.56382C3.69462 8.31607 3.69462 7.91425 3.91615 7.6665C4.13757 7.41862 4.49666 7.41862 4.71808 7.6665L6.12823 9.24438L9.53181 5.43582C9.75333 5.18806 10.1124 5.18806 10.3339 5.43582Z",
    fill: "#29185E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.d79779c36a539c4c0ced58bc2d82fad6.svg";
export { ForwardRef as ReactComponent };